<template>
	<v-container fluid>
		<div v-if="!loading">
		<!--table content-->
		<v-expansion-panels multiple v-model="panel">
			<v-expansion-panel>
				<v-expansion-panel-header class="subtitle-2 secondary--text" expand-icon="mdi-menu-down">
					Company advertising 
				</v-expansion-panel-header>
				<v-expansion-panel-content>
					<!--table-->
					<!--table head-->
					<v-row class="total mt-8" no-gutters>
						<v-col class="tabCell text-left">Spot name</v-col>
						<v-col v-for="item in headers"
							class="tabCell"
							:key="item">{{item}}
						</v-col>
					</v-row>
					<!--tab content-->
					<div v-if="companySpots">
						<v-row v-for="companySpot in companySpots" :key="companySpot.id" no-gutters>
							<v-col class="tabCell text-left">{{ companySpot.name }}</v-col>
							<v-col class="tabCell">{{ companySpot.coreFeature }}</v-col>
							<v-col class="tabCell">{{ companySpot.advancedFeature }}</v-col>
							<v-col class="tabCell">{{ companySpot.price }}</v-col>
							<v-col class="tabCell">{{ values(companySpot.value) }}</v-col>
							<v-col class="tabCell">{{ companySpot.channels }}</v-col>
							<v-col class="tabCell">{{ investments(companySpot) }}</v-col>
							<v-col class="tabCell">
								<delete-spot
									:spot="companySpot"
									:gameId="gameId"
									:round="round">
								</delete-spot>
								<upgrade-spot
									:spot="companySpot"
									:gameId="gameId"
									:round="round">	
								</upgrade-spot>
							</v-col>
						</v-row>
					</div>
					<div v-if="posibility">
						<v-row class="mt-4" justify="end">
							<add-spot
								:type="0"
								:gameId="gameId"
								:round="round"
								:company="company">
							</add-spot>
						</v-row>
					</div>
				</v-expansion-panel-content>
			</v-expansion-panel>
			<v-expansion-panel>
				<v-expansion-panel-header class="subtitle-2 secondary--text" expand-icon="mdi-menu-down">
					Trademarks advertising  
				</v-expansion-panel-header>
				<v-expansion-panel-content>
					<!--table-->
					<!--table head-->
					<v-row class="mt-8 total" no-gutters>
						<v-col class="tabCell text-left">Spot name</v-col>
						<v-col v-for="item in headers2"
							class="tabCell"
							:key="item">{{item}}
						</v-col>
					</v-row>
					<!--tab content-->
					<div v-if="brandSpots">
						<v-row v-for="spot in brandSpots" :key="spot.id"  no-gutters>
							<v-col class="tabCell text-left">{{ spot.name }}</v-col>
							<v-col class="tabCell">{{ spot.trademark }}</v-col>
							<v-col class="tabCell">{{ spot.coreFeature }}</v-col>
							<v-col class="tabCell">{{ spot.advancedFeature }}</v-col>
							<v-col class="tabCell">{{ spot.price }}</v-col>
							<v-col class="tabCell">{{ values(spot.value) }}</v-col>
							<v-col class="tabCell">{{ spot.channels }}</v-col>
							<v-col class="tabCell">{{ investments(spot) }}</v-col>
							<v-col class="tabCell">
								<delete-spot
									:spot="spot"
									:gameId="gameId"
									:round="round">	
								</delete-spot>
								<upgrade-spot
									:spot="spot"
									:gameId="gameId"
									:round="round">	
								</upgrade-spot>
							</v-col>
						</v-row>
					</div>
					<v-row class="mt-4" justify="end">
						<add-spot
							:type="1"
							:gameId="gameId"
							:round="round"
							:company="company">
						</add-spot>
					</v-row>
				</v-expansion-panel-content>
			</v-expansion-panel>
		</v-expansion-panels>
		</div>
		<div v-else class="text-center">
			<loader></loader>
		</div> 
	</v-container>
</template>
<script>

	import addSpot from '../spots/addSpot.vue'
	import deleteSpot from '../spots/deleteSpot.vue'
	import upgradeSpot from '../spots/upgradeSpot.vue'
	import Loader from '../../layouts/Loader.vue'

	import numeral from 'numeral'

	export default {
		props: ['gameId', 'round', 'company'],
		data (){
			return {
				icon: 'arrow_right',
				headers: ['Core product feature', 'Advanced product feature', 'Price', 'Values', 'Quality level', 'Investments', 'Action'],
				headers2: ['Trademark', 'Core product feature', 'Advanced product feature', 'Price', 'Values', 'Quality level', 'Investments', 'Action'],
				panel: [0, 1]
			}
		},		
		computed: {
			loading () {
				return this.$store.getters.loading
			},
			companySpots () {
				return this.$store.getters.companySpots
			},
			brandSpots () {
				return this.$store.getters.brandSpots
			},
			trademarks () {
				return this.$store.getters.trademarks
			},
			posibility () {
				return Boolean(this.companySpots.length <= 5)
			}

		},
		methods: {
			investments (spot) {
				return numeral(spot.investments).format('0,0[.]0')
			},
			values (value) {
				let val = value
				switch (value) {
					case 'family': val+= ' / kids'
					break;
					case 'attractiveness': val = 'personal attractiveness';
					break;
					case 'strongPerson': val = 'strong personality';
					break;
					case 'socStatus': val = 'social status';
				}

				return val
			}
		},
		components: {
			addSpot,
			deleteSpot,
			upgradeSpot,
			Loader
		}
	}
</script>

